import { createFileRoute, Outlet, useMatches, useRouterState } from '@tanstack/react-router'
import { useState } from 'react';

import { NavBar } from '@/components/layout/navBar'
import { PageContainer } from '@/components/layout/pageContainer'
import { TopBar } from '@/components/layout/topBar'
import { Authenticated } from '@/providers/authenticated'
import { pageWidthOf } from '@/util/pageWidth'

export const Route = createFileRoute('/dashboard/_authenticated')({
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const pageWidth = pageWidthOf(useMatches());

  // Collapse the mobile sidebar overlay whenever the route changes
  // (derived-state-during-render, avoids a setState-in-effect roundtrip).
  const [lastPathname, setLastPathname] = useState(pathname);
  if (pathname !== lastPathname) {
    setLastPathname(pathname);
    setIsNavOpen(false);
  }

  return (
    <Authenticated>
      {({ isLoggedIn }) => {
        if (!isLoggedIn) {
          return;
        }
        return (
          <div className="flex h-screen flex-col">
            <div><TopBar onToggleNav={() => setIsNavOpen((open) => !open)} /></div>
            <div className="relative flex min-h-0 flex-1 overflow-hidden">
              {isNavOpen && (
                <button
                  aria-label="Close navigation"
                  className="
                    fixed inset-0 z-30 bg-neutral-800/40
                    lg:hidden
                  "
                  onClick={() => setIsNavOpen(false)}
                  type="button"
                />
              )}
              <div className={`
                fixed inset-y-0 left-0 z-40 h-full transition-transform
                duration-200
                lg:static lg:z-auto lg:translate-x-0
                print:hidden
                ${isNavOpen ? 'translate-x-0' : '-translate-x-full'}
              `}>
                <NavBar />
              </div>
              {/* The only place with page padding; pages choose their width via `staticData.pageWidth`.
                  overflow-x-clip (not a scroll container, so sticky bars still work) cuts full-bleed
                  layers (`bleed-x`) at the content edges without adding sideways scroll. */}
              <div className="
                min-h-0 w-full flex-1 overflow-x-hidden overflow-y-auto pt-10
                pb-4
                lg:pt-15
              ">
                <div className="grid min-h-full overflow-x-clip px-gutter">
                  <PageContainer width={pageWidth}>
                    <Outlet />
                  </PageContainer>
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </Authenticated>
  )
}
